import { SxProps } from "@mui/material";

export const JournalAccordion: SxProps = {
  boxShadow: "none",
  border: "1px solid #E5E7EB",
  borderRadius: "8px !important",
  mb: 2,
  "::before": {
    backgroundColor: "transparent",
  },
};

export const previewWrapper: SxProps = {
  height: "calc(100% - 85px)",
  overflow: "auto",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "#fafafa",
  "&::before": {
    content: "''",
    margin: "auto",
    minHeight: "20px",
  },
  "&::after": {
    content: "''",
    margin: "auto",
    minHeight: "20px",
  },
};

export const previewContainer: SxProps = {
  width: "360px",
  height: "600px",
  flexShrink: 0,
  boxShadow: 1,
  borderRadius: "16px",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  scrollBehavior: "smooth",
  backgroundColor: "#FFFFFF",
  "&::-webkit-scrollbar": {
    width: "4px",
  },
};

export const FaqManagerContent: SxProps = {
  display: "flex",
  gap: 3,
  height: "calc(100vh - 241px)",
  alignItems: "start",
};

export const SectionCard: SxProps = {
  bgcolor: "#fff",
  boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.08)",
  borderRadius: 2,
  minHeight: "1px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  maxHeight: "100%",
};

export const HeaderStyle: SxProps = {
  minHeight: "70px",
  px: 2,
  py: 1,
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 1,
};

export const SectionCardContent: SxProps = {
  flex: 1,
  minHeight: "1px",
  overflow: "hidden",
  "&:hover": {
    overflow: "auto",
  },
};
